import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WebinarCard from '../../../../../../dashboardNew/components/cards/WebinarCard';

class WebinarList extends Component {
    render() {

        const webinarList = this.props.webinars.webinarsList;
        return (
            <div className="row">
                { webinarList.map( ( webinar, index ) => {
                    return (
                        <WebinarCard key={ index } index={ index } webinar={webinar}  />
                    );
                } ) }
            </div>
        );
    };
}

WebinarList.proptypes = {
    webinars: PropTypes.object.isRequired,
    // network: PropTypes.string.isRequired,
};

export default WebinarList;



// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/WebinarList.js